import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import JobTypeSearch from 'modules/job-types/components/JobTypeSearch';

import Banner from './Banner';
import { Category } from 'modules/marketing-pages/marketing-page.types';
import { JobType } from 'modules/job-types/types';

import styles from './BannerJobTypeSearch.module.scss';

interface Props {
  bgImg: string;
  categoryTree: Category;
  subtitle: string;
  title: string;
  popular?: Array<JobType>;
}

const BannerJobTypeSearch: FC<Props> = ({ bgImg, categoryTree, subtitle, title, popular }) => {
  const { t } = useTranslation();
  const popularJobTypeSearch = popular?.map((jobType) => ({
    id: jobType.id,
    title: jobType.translations?.requestType ?? jobType.title,
  }));

  return (
    <Banner bgImg={bgImg} alt={title}>
      <div className={styles.content}>
        <h1 className={styles.title}>{title}のプロと出会う。</h1>
        <p className={styles.subtitle}>{subtitle}</p>
        <div className={styles.job}>
          <JobTypeSearch
            buttonText={t('jobTypeSelect.searchPro')}
            id="bannerJobTypeSearch"
            isButtonAnimated={true}
            pageType={categoryTree.categoryLevel}
            popular={popularJobTypeSearch}
          />
        </div>
      </div>
    </Banner>
  );
};

export default BannerJobTypeSearch;
